import {TCustomIconButtonProps} from "@/app/[locale]/common/components/CustomIconButton/types";
import s from './CustomIconButton.module.scss';

export const CustomIconButton = (
    {
        leftIcon,
        rightIcon,
        leftMargin,
        className,
        children,
        onClick,
        onMouseOver,
        onMouseOut,
    }: TCustomIconButtonProps) => {
    return (
        <button className={`${s.button} ${className}`} aria-label="Customise options" onClick={onClick} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            {leftIcon && <span className={`${s.iconContainer} ${s.leftIcon}`}>{leftIcon}</span>}
            { children && <span className={`${s.text} ${leftMargin && s[leftMargin]}`}>{ children }</span> }
            {rightIcon && <span className={s.iconContainer}> {rightIcon} </span>}
        </button>
    );
};